import {
	BY_POPULARITY,
	BY_PRICE_AND_POPULARITY,
	BY_SCORE_AND_POPULARITY,
	sorters,
} from "@escapio/portal/components/hotel-list/sorting/Sorters";
import { STATE_DIRECT_LINK_ONLY } from "@escapio/portal/state/HotelPriceLoadingStates";
import { contains as favoritesContain } from "@escapio/portal/state/FavoriteHotels";
import { hasPrice } from "@escapio/portal/components/hotel-list/hotel-has-prices";
import { inTheNear } from "@escapio/portal/components/hotel-list/hotel-is-in-the-near";
import { travelData } from "@escapio/portal/state/travelData.js";

export const sort = (prices, currentSorting, topHotelId) => {
	if (!sorters.hasOwnProperty(currentSorting)) {
		throw new Error(`Invalid sorting value: ${currentSorting}`);
	}

	return (a, b) => {
		if (inTheNear(a) !== inTheNear(b)) {
			// no distance hotels first
			return !inTheNear(a) ? -1 : 1;
		}

		if (a.id === topHotelId) {
			return -1;
		}

		if (b.id === topHotelId) {
			return 1;
		}

		const isSortingWithPrice = currentSorting === BY_PRICE_AND_POPULARITY;
		const belongsPriceGroup = hotel =>
			hasPrice(prices, hotel.id) ||
			(!isSortingWithPrice && hotel.disabled_prices && travelData.hasDates);

		if (belongsPriceGroup(a) && !belongsPriceGroup(b)) {
			return -1;
		}
		if (!belongsPriceGroup(a) && belongsPriceGroup(b)) {
			return 1;
		}

		if (currentSorting === BY_POPULARITY) {
			if (favoritesContain(a.id) && !favoritesContain(b.id)) {
				return -1;
			}

			if (!favoritesContain(a.id) && favoritesContain(b.id)) {
				return 1;
			}
		}

		const isDirectLinkOnly = ({ id }) =>
			prices[id]?.pricesState === STATE_DIRECT_LINK_ONLY;
		const factor =
			currentSorting !== BY_SCORE_AND_POPULARITY &&
			isDirectLinkOnly(a) &&
			isDirectLinkOnly(b)
				? -1
				: 1;
		return factor * sorters[currentSorting](prices, travelData.hasDates)(a, b);
	};
};
